import styled from "@emotion/styled";
import { fontBarlowSemiCondensed, fontPlayfairDisplay } from "@product/scmp-sdk";

import { AuthorName } from "~/components/author/author-name";
import { EntityLink } from "~/components/entity-link";

export type StyledProps = {
  $isMultipleAuthors?: boolean;
};

export const StyledEntityLink = styled(EntityLink)`
  color: #222222;
`;

export const Cover = styled.div`
  display: flex;
  justify-content: center;
`;
export const Headline = styled.div`
  padding-block-start: 8px;

  font-weight: 400;
  font-size: 48px;
  font-family: ${fontPlayfairDisplay};
  line-height: 56px;
  text-align: center;

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block: 0;
    padding-inline: 120px;
  }
  ${props => props.theme.breakpoints.only("mobile")} {
    font-size: 28px;
    line-height: 34px;
  }
`;
export const StoryLabel = styled.span`
  font-weight: 700;
`;
export const StyledAuthorName = styled(AuthorName)`
  color: #222222;
`;
export const AuthorNameWrapper = styled.span`
  & + & {
    &::before {
      content: "/";

      margin-inline-start: 4px;
      margin-inline-end: 4px;

      text-decoration: none;

      pointer-events: none;
    }
  }
`;
export const AuthorNameContainer = styled.div<StyledProps>`
  display: flex;
  flex-direction: ${props => (props.$isMultipleAuthors ? "column" : "row")};
  row-gap: 4px;
  justify-content: center;

  font-weight: 400;
  font-size: 16px;
  font-family: ${fontBarlowSemiCondensed};
  text-align: center;
  text-transform: uppercase;
  column-gap: 6px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  justify-content: center;
  align-content: center;
`;
